import { useQuery } from "@tanstack/react-query";

import {
  ComputePackMinBuyingPriceBody,
  requestComputePackMinBuyingPrice
} from "./computePackMinBuyingPrice.request";

const QUERY_KEY = "pack-min-buying-price-combination";

/**
 * Live preview of the pack's buying-price floor (sum of cheapest variant
 * buyingPrice per slot). Re-fetches when the slot selection changes so the
 * admin form's read-only "Buying Price" input updates as variants are added
 * or removed.
 */
export const useComputePackMinBuyingPrice = (
  body: ComputePackMinBuyingPriceBody,
  enabled: boolean = true
) => {
  const hasAnyVariants = body.slots.some((s) => s.variantIds.length > 0);

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEY, body],
    queryFn: () => requestComputePackMinBuyingPrice(body),
    enabled: enabled && hasAnyVariants,
    staleTime: 30_000,
    keepPreviousData: true
  });

  return {
    minBuyingPriceCombination: data?.minBuyingPriceCombination ?? 0,
    ...rest
  };
};
